import { useEffect } from "react";
import Nav from "@/components/sections/Nav";
import Hero from "@/components/sections/Hero";
import Stats from "@/components/sections/Stats";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import AIEnhanced from "@/components/sections/AIEnhanced";
import Work from "@/components/sections/Work";
import Activations from "@/components/sections/Activations";
import Brands from "@/components/sections/Brands";
import Process from "@/components/sections/Process";
import CTA from "@/components/sections/CTA";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function Landing() {
    useEffect(() => {
        document.title = "AE — Amplify Everything. AI-Enhanced Advertising Agency";
    }, []);

    return (
        <main
            data-testid="ae-landing-root"
            className="relative min-h-screen w-full bg-white text-ae-charcoal selection:bg-ae-orange selection:text-white"
        >
            <Nav />
            <Hero />
            <Stats />
            <About />
            <Services />
            <AIEnhanced />
            <Work />
            <Activations />
            <Brands />
            <Process />
            <CTA />
            <Contact />
            <Footer />
        </main>
    );
}
